export interface IAddHospitalPrescriptionRefillRequest {
  hospitalPrescriptionId: number;
  hospitalPrescriptionRefillStatusId: number;
  hospitalId: number;
  hospitalPrescriptionRowVersion: string;
  requestedPickupDate: string | undefined;
}

export class AddHospitalPrescriptionRefillRequest
  implements IAddHospitalPrescriptionRefillRequest
{
  hospitalPrescriptionId: number;
  hospitalPrescriptionRefillStatusId: number;
  hospitalId: number;
  hospitalPrescriptionRowVersion: string;
  requestedPickupDate: string | undefined;

  constructor(params: IAddHospitalPrescriptionRefillRequest) {
    this.hospitalPrescriptionId = params.hospitalPrescriptionId;
    this.hospitalPrescriptionRefillStatusId =
      params.hospitalPrescriptionRefillStatusId;
    this.hospitalId = params.hospitalId;
    this.hospitalPrescriptionRowVersion = params.hospitalPrescriptionRowVersion;
    this.requestedPickupDate = params.requestedPickupDate;
  }

  static ParseAddHospitalPrescriptionRefillRequest(
    hospitalPrescriptionId: number,
    hospitalPrescriptionRefillStatusId: number,
    hospitalId: number,
    hospitalPrescriptionRowVersion: string,
    requestedPickupDate: string | undefined,
  ): IAddHospitalPrescriptionRefillRequest {
    return {
      hospitalPrescriptionId,
      hospitalPrescriptionRefillStatusId,
      hospitalId,
      hospitalPrescriptionRowVersion,
      requestedPickupDate,
    };
  }
}
